module.exports = __webpack_public_path__ + "static/background1-edba5867105edb34b66992adb1450cd0.svg";